import ContractPartyMasterQuery from '@/api/user_contract/contract_party_master/query.js';
import ContractPartyMasterCreate from '@/api/user_contract/contract_party_master/create.js';
import ContractPartyMasterUpdate from '@/api/user_contract/contract_party_master/update.js';

export const contractPartyMaster = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    contractPartyMasters: []
  },
  getters: {
    contractPartyMasters: state => state.contractPartyMasters
  },
  mutations: {
    setContractPartyMasters(state, contractPartyMasters) {
      state.contractPartyMasters = contractPartyMasters;
    },
    clear(state) {
      state.contractPartyMasters = [];
    }
  },
  actions: {
    setContractPartyMasters({ commit }, contractPartyMasters) {
      commit('setContractPartyMasters', contractPartyMasters);
    },
    clearContractPartyMasters({ commit }) {
      commit('clear');
    },
    async setLatestContractPartyMasters({ commit, state }) {
      if (!state.contractPartyMasters.length) {
        // 最新版を設定する。
        await ContractPartyMasterQuery.filterContractPartyMasterByCompanyId().then(res => {
          commit('setContractPartyMasters', res.data.data);
        });
      }
    },
    async createContractPartyMaster({ commit }, payload) {
      await ContractPartyMasterCreate.createContractPartyMaster(payload.contractPartyMasterId, payload.contractPartyName);
    },
    async createNotExistContractPartyMasters({ commit }, payload) {
      if (payload.contractPartyList.length !== 0) {
        await ContractPartyMasterCreate.createNotExistContractPartyMaster(
          payload.contractPartyList
        );
      }
    },
    updateContractPartyMaster({ commit }, payload) {
      ContractPartyMasterUpdate.updateContractPartyMaster(payload.contractPartyMasterId, payload.contractPartyName);
    },
    deleteContractPartyMaster({ commit }, payload) {
      ContractPartyMasterUpdate.deleteContractPartyMaster(payload.contractPartyMasterId);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/contract_party_master.js